module.exports = __webpack_public_path__ + "static/media/user.be571b90.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user.svg
// module id = 100
// module chunks = 0